module.exports = require('./lib/srp');

module.exports.params = require('./lib/params');
